import { Stack, Text, AspectRatio, Box } from '@chakra-ui/react';
import { NestedHome, NestedProject } from '@habity/types';
import { extractEmbeddedLinks } from '~/utils/embeddedLinks';

interface EmbeddedLinksProps {
  entity: NestedHome | NestedProject;
}

export const EmbeddedLinks = ({ entity }: EmbeddedLinksProps) => {
  const embeddedLinks = extractEmbeddedLinks(entity);

  // Don't render anything if no links
  if (embeddedLinks.length === 0) {
    return null;
  }

  return (
    <Stack spacing="4" mb="6">
      {embeddedLinks.map((link, index) => (
        <Stack key={`link-${index}`} spacing="2">
          <Text fontWeight="light" size={{ mobile: 'sm', desktop: 'md' }}>
            {link.title}
          </Text>

          <AspectRatio ratio={16 / 9} maxW="100%">
            <Box
              as="iframe"
              src={link.embedUrl}
              title={link.title}
              allowFullScreen
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              style={{
                borderRadius: '8px',
                border: '1px solid',
                borderColor: 'var(--chakra-colors-blackAlpha-200)',
              }}
            />
          </AspectRatio>
        </Stack>
      ))}
    </Stack>
  );
};
